export type EpiAccount = {
	id: string;
	isActive: boolean;
	fps: FinancialPlanningSoftware[];
};

export const EpiAccountDoesNotExist: EpiAccount = {
	id: '',
	isActive: true,
	fps: [],
};

export type FinancialPlanningSoftware = {
	id: number;
	value: string;
};

export type ClientDataExchangePreference = {
	products: FinancialPlanningSoftware[];
};
